import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { GeneralError, SpinnerButton } from 'components';
import { UserService } from 'frilans-finans';

class ConfirmEmail extends Component {

  static propTypes = {
    email: PropTypes.string,
    emailConfirmed: PropTypes.bool
  }

  constructor (props) {
    super(props);

    this.state = {
      loading: false,
      error: true,
      errorMessage: [proxyCounterpart('EMAIL_NOT_CONFIRMED', { email: this.props.email })]
    };

    this.resetPassword = this.resetPassword.bind(this);
  }

  resetPassword (e) {
    e.preventDefault();
    this.setState({
      loading: true
    });

    UserService.resetPassword(this.props.email)
      .then(() => {
        this.setState({
          loading: false,
          error: false
        });
      }).catch((error) => {
        let errors = UserService.getError(error);

        this.setState({
          loading: false,
          error: true,
          errorMessage: errors
        });
      });
  }

  success () {
    return !this.state.error && !this.state.loading;
  }

  renderSuccess () {
    if (this.success()) {
      return (<p className='info'><Translate content='RESET_PASSWORD_SUCCESS'/></p>);
    }
  }

  renderError () {
    if (this.state.error) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
          {this.state.errorMessage.map((error, i) => {
            return (
              <p className="error" key={i}>{error}</p>
            );
          })}
          </div>
        );
      }
    }
  }

  render () {
    if (!this.props.emailConfirmed) {
      return (
        <div className="mb35">
          {this.renderError()}
          {this.renderSuccess()}

          <SpinnerButton text={proxyCounterpart('SEND_VERIFICATION_MAIL')}
            loading={this.state.loading}
            classes='btn'
            disabled={this.success()}
            callback={this.resetPassword} />
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps (state) {
  return {
    email: state.user.email,
    emailConfirmed: state.user.emailConfirmed
  };
}

export default connect(mapStateToProps)(ConfirmEmail);



/** WEBPACK FOOTER **
 ** ./src/views/settings/change-password/confirm-email.js
 **/